import { SecretAlgorithm, SecretRow } from "namirasoft-secret";
import { NSMenuActionProps } from "namirasoft-site-react";

export class SecretMenus
{
	static RetrieveValue(getIDs: () => string[], getRows: () => SecretRow[], handler: (id: string) => void): NSMenuActionProps
	{
		return {
			id: "1",
			menu_item: "Retrieve Value",
			isActive: () =>
			{
				if (getIDs().length === 1)
				{
					let secret = getRows()[0];
					if (secret)
						return secret.algorithm === SecretAlgorithm.ENCRYPT_AES256CCM
				}
				return false;
			},
			onClick: {
				action: () =>
				{
					let id = getIDs();
					handler(id[0]);
				},
				showLoading: false
			}
		}
	}
}